
// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import "./login.css";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPwd, setShowPwd] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [err, setErr] = useState("");
//   const navigate = useNavigate();


//   useEffect(() => {
//      const token = sessionStorage.getItem("token"); // ✅ changed
//     if (token) {
//       navigate("/dashboard/");
//     }
//   }, [navigate]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     // setErr("");

   
//     if (password.length < 6) {
//       setErr("Password must be at least 6 characters");
//       console.log("Login error:", err);
//       return;
//     }

//     try {
//       setLoading(true);

//       const res = await fetch("https://bodhimaram.onrender.com/login", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, password }),
//       });

//       const data = await res.json();

//       if (!res.ok) {
//         setErr(data.error || "Login failed");
//         return;
//       }

//       // ✅ Save token & user info
//     sessionStorage.setItem("token", data.token);
// sessionStorage.setItem("user", JSON.stringify(data.user));

//       console.log("✅ Logged in:", data.user);

//       // Redirect to dashboard
//       navigate("/dashboard/");
//     } catch (e2) {
//       console.error("Login error:", e2);
//       setErr("Something went wrong, try again later.");
//       console.log("err"+e2)
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="auth-page">
//       <div className="auth-card">
//         <div className="brand">
//           <div className="logo1">Bodhimaram Play School</div>
//           <h1>Welcome back</h1>
//           <p className="subtitle">Sign in to continue</p>
//         </div>

//        <form onSubmit={handleSubmit} method="post" autoComplete="on" className="auth-form">
//   <label>Email</label>
//   <input
//     type="text"
//     name="email"
//     placeholder="you@example.com"
//     value={email}
//     onChange={(e) => setEmail(e.target.value)}
//     autoComplete="email"
//     required
//   />

//   <label>Password</label>
//   <div className="pwd-wrap">
//     <input
//       type={showPwd ? "text" : "password"}
//       name="password"
//       placeholder="••••••••"
//       value={password}
//       onChange={(e) => setPassword(e.target.value)}
//       autoComplete="current-password"
//       required
//     />
//     <button
//       type="button"
//       className="pwd-toggle"
//       onClick={() => setShowPwd((s) => !s)}
//     >
//       {showPwd ? "Hide" : "Show"}
//     </button>
//   </div>
//   {err && <div className="form-error">{err}</div>}
//   <div className="row-between">
//     <label className="checkbox">
//       <input
//         type="checkbox"
//         onChange={(e) => {
//           if (e.target.checked) {
//             sessionStorage.setItem("rememberEmail", email);
//           } else {
//             sessionStorage.removeItem("rememberEmail");
//           }
//         }}
//       />
//       <span>Remember me</span>
//     </label>
//     <Link to="/forget-password" className="link">
//       Forgot password?
//     </Link>
//   </div>

//   <button className="primary-btn" type="submit" disabled={loading}>
//     {loading ? "Signing in…" : "Login"}
//   </button>
// </form>


//         <p className="footer-note">
//           Don’t have an account? <a href="#">Contact admin</a>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Login;




import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./login.css";
import logintop from "../components/groups/logintop.png"
import {
  Mail,
  Lock,
  Eye,
  EyeOff,
  Download,
  ArrowRight,
} from "lucide-react";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const [deferredPrompt, setDeferredPrompt] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (token) {
      navigate("/dashboard/");
    }
  }, [navigate]);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();

      console.log("PWA Install Available");

      setDeferredPrompt(e);
    };

    window.addEventListener(
      "beforeinstallprompt",
      handleBeforeInstallPrompt
    );

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const installApp = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();

      const { outcome } =
        await deferredPrompt.userChoice;

      console.log("Install Status:", outcome);

      setDeferredPrompt(null);
    } else {
      alert(
        "Install option not available.\n\nChrome Menu (⋮)\n→ Add to Home Screen"
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 6) {
      setErr("Password must be at least 6 characters");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(
        "https://bodhimaram.onrender.com/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            password,
          }),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        setErr(data.error || "Login failed");
        return;
      }

      sessionStorage.setItem("token", data.token);

      sessionStorage.setItem(
        "user",
        JSON.stringify(data.user)
      );

      console.log("Logged in:", data.user);

      navigate("/dashboard/");
    } catch (e2) {
      console.error("Login error:", e2);
      setErr("Something went wrong, try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">

      <div className="login-header">

    <img
        src={logintop}
        alt="Bodhimaram"
        className="login-top-image"
    />

    <h1 className="schoolname">
        Bodhimaram Play School
    </h1>

    {/* <p className="school-subtitle">
        Smart Preschool Management
    </p> */}

    <div className="school-features">

        <span>Fees</span>

        <span>•</span>

        <span>Attendance</span>

        <span>•</span>

        <span>Transport</span>

        <span>•</span>

        <span>Communication</span>

    </div>

</div>
      <div className="login-card">

        

        
     <form
  onSubmit={handleSubmit}
  autoComplete="on"
  className="auth-form"
>

  {/* Welcome */}

  <div className="form-title">

    {/* <h2>
      Welcome Back <span>👋</span>
    </h2> */}

    <h2>Sign in to continue</h2>

  </div>

  {/* Email */}

  <div className="input-box">

    <Mail size={20} className="input-icon" />

    <input
      type="email"
      placeholder="Email address"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      autoComplete="email"
      required
    />

  </div>

  {/* Password */}

  <div className="input-box">

    <Lock size={20} className="input-icon" />

    <input
      type={showPwd ? "text" : "password"}
      placeholder="Password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      autoComplete="current-password"
      required
    />

    <button
      type="button"
      className="eye-btn"
      onClick={() => setShowPwd(!showPwd)}
    >

      {showPwd ? (
        <EyeOff size={22} />
      ) : (
        <Eye size={22} />
      )}

    </button>

  </div>

  {err && (
    <div className="form-error">
      {err}
    </div>
  )}

  {/* Remember */}

  <div className="row-between">

    <label className="checkbox">

      <input
        type="checkbox"
        onChange={(e) => {
          if (e.target.checked) {
            sessionStorage.setItem(
              "rememberEmail",
              email
            );
          } else {
            sessionStorage.removeItem(
              "rememberEmail"
            );
          }
        }}
      />

      <span>Remember me</span>

    </label>

    <Link
      to="/forget-password"
      className="link"
    >
      Forgot Password?
    </Link>

  </div>

  {/* Login */}

  <button
    className="primary-btn"
    type="submit"
    disabled={loading}
  >

    <span>

      {loading ? "Signing in..." : "Login"}

    </span>

    <ArrowRight
    size={24}
    strokeWidth={2.5}
/>

  </button>

  {/* Install */}

 <button
    type="button"
    className="install-btn"
    onClick={installApp}
>

    <Download
        size={22}
        strokeWidth={2.3}
    />

    <span>

        Install Application

    </span>

</button>

  

</form>   

        <p className="footer-note">

    <span className="footer-text">
        Need an account?
    </span>

    <a href="tel:+919876543210">
        Contact Administrator
    </a>

</p>
      </div>
    </div>
  );
};

export default Login;
